import accessibilityFontsService from '@/services/accessibilityFontsService';
import themeService from '@/services/themeService';
import * as Mutations from '../../mutations';
import i18n from '../../../i18n/i18n';

const defaultFontSize = 'manage-fonts_14px';

export default {
  setLanguage({ commit, getters }, language) {
    i18n.locale = (language && language.key) || i18n.defaultLanguage;
    commit(Mutations.SET_LANGUAGE, language || getters.getLanguage(i18n.defaultLanguage));
  },
  increaseFont({ commit, getters }) {
    if (getters.nextFontSize) {
      accessibilityFontsService.setClass(getters.nextFontSize);
      commit(Mutations.SET_FONT_SIZE, getters.nextFontSize);
    }
  },
  decreaseFont({ commit, getters }) {
    if (getters.previousFontSize) {
      accessibilityFontsService.setClass(getters.previousFontSize);
      commit(Mutations.SET_FONT_SIZE, getters.previousFontSize);
    }
  },
  setFontSize({ commit }, fontClass) {
    const fontClassToApply = fontClass || defaultFontSize;
    accessibilityFontsService.setClass(fontClassToApply);
    commit(Mutations.SET_FONT_SIZE, fontClassToApply);
  },
  setDarkTheme({ commit }) {
    themeService.setTheme(themeService.themes.DARK);
    commit(Mutations.SET_APP_THEME, themeService.themes.DARK);
  },
  setLightTheme({ commit }) {
    themeService.setTheme(themeService.themes.LIGHT);
    commit(Mutations.SET_APP_THEME, themeService.themes.LIGHT);
  },
  setConfiguration({ commit }, configuration) {
    commit(Mutations.SET_APP_CONFIGURATION, configuration);
  },
  setErrorGettingConfiguration({ commit }) {
    commit(Mutations.SET_ERROR_GETTING_APP_CONFIGURATION);
  },
  setPrintingMode({ commit }, state) {
    commit(Mutations.SET_PRINTING_MODE, state);
  },
  setApiUnreachable({ commit }, value) {
    commit(Mutations.SET_API_UNREACHABLE, value);
  },
};
